export type Language = 'no' | 'en';
export type TranslationKey = keyof typeof translations.no;

export const translations = {
    no: {
        // Common
        'app.name': 'TipsNorge',
        'loading': 'Laster...',
        'error': 'En feil oppstod',
        'submit': 'Send inn',
        'cancel': 'Avbryt',
        'common.unnamed': 'Navnløs bruker',
        'common.syncing': 'Synkroniserer',
        'common.offline': 'Frakoblet',
        'common.sending': 'Sender...',
        'common.loading': 'Laster...',
        'common.load_more': 'Last flere',
        'common.version': 'Versjon',
        'common.share': 'Del',
        'common.or': 'eller',
        'common.link_copied': 'Lenke kopiert til utklippstavle',
        'common.name_label': 'Navn:',
        'common.phone_label': 'Telefon:',
        'back': 'Tilbake',
        'save': 'Lagre',
        'create': 'Opprett',
        'edit': 'Rediger',
        'delete': 'Slett',
        'close': 'Lukk',
        'common.error_unauthorized': 'Du har ikke tilgang til denne ressursen',
        'contact.check_faq': 'Før du sender melding:',
        'contact.check_faq_link': 'Sjekk om du finner svaret i Hjelpesenteret',
        'about.ready_to_contribute': 'Klar til å bidra?',
        'legal.privacy_contact_title': 'Personvernombud',
        'legal.privacy_contact_desc': 'For spørsmål om personvern, kontakt oss direkte på:',
        'confirm': 'Bekreft',
        'yes': 'Ja',
        'no': 'Nei',
        'legal.terms': 'Brukervilkår',
        'legal.privacy': 'Personvern',
        'legal.copyright': '© 2026 TipsNorge. Alle rettigheter reservert.',
        'legal.last_updated': 'Sist oppdatert',
        'legal.privacy_title': 'Personvernerklæring',
        'legal.privacy_intro': 'TipsNorge behandler data i samsvar med GDPR og norsk personopplysningslov. Vi samler kun inn nødvendig informasjon for å kunne behandle dine saker.',
        'legal.privacy_section1_title': '2. Hvilke data samler vi inn?',
        'legal.privacy_section1_desc': 'Vi samler inn følgende data for å kunne levere tjenesten:',
        'legal.privacy_data_location': 'Posisjonsdata (GPS-koordinater) for å vite hvor problemet befinner seg.',
        'legal.privacy_data_images': 'Bilder for dokumentasjon. Bilder analyseres av AI, men lagres sikkert.',
        'legal.privacy_data_contact': 'Kontaktinformasjon som e-post dersom du velger å registrere en konto.',
        'legal.privacy_section2_title': '3. Formål med behandlingen',
        'legal.privacy_section2_desc': 'Hovedformålet er å formidle informasjon om feil og mangler til rette myndighet (kommune, fylkeskommune eller stat) for utbedring av infrastruktur.',
        'legal.privacy_section3_title': '4. Datasikkerhet',
        'legal.privacy_section3_desc': 'Vi bruker moderne kryptering og sikre servere levert av Supabase for å beskytte dine data mot uautorisert tilgang.',
        'legal.privacy_section4_title': '5. Dine rettigheter',
        'legal.privacy_section4_desc': 'Du har rett til innsyn i egne opplysninger, samt rett til å kreve sletting eller korrigering av ufullstendige data. Du kan slette din konto og alle tilhørende data direkte fra din profilside.',

        'legal.terms_title': 'Brukervilkår',
        'legal.terms_date': '19. januar 2026',
        'legal.terms_intro': 'Ved å bruke TipsNorge aksepterer du disse brukervilkårene. Tjenesten leveres "som den er" for å forenkle innsending av saker om infrastrukturproblemer til norske myndigheter.',
        'legal.terms_section1_title': 'Bruk av tjenesten',
        'legal.terms_section1_desc': 'Du forplikter deg til å bruke tjenesten på en ansvarlig måte:',
        'legal.terms_rule1': 'Kun melde fra om reelle problemer i det offentlige rom.',
        'legal.terms_rule2': 'Ikke inkludere personopplysninger eller irrelevant informasjon i saker.',
        'legal.terms_rule3': 'Ikke bruke tjenesten til sjikane, spam eller sabotasje.',
        'legal.terms_section2_title': 'Bildebruk',
        'legal.terms_section2_desc': 'Ved opplasting av bilder bekrefter du at du har rett til å dele bildet. Unngå å ta bilder av ansikter eller bilskilt for å beskytte personvernet til tredjepersoner.',
        'legal.terms_section3_title': 'Begrensning av ansvar',
        'legal.terms_section3_desc': 'TipsNorge er en plattform for formidling. Vi garanterer ikke at alle saker blir utbedret, da dette avhenger av prioriteringer hos den enkelte myndighet.',
        'legal.terms_section4_title': 'Immaterielle rettigheter',
        'legal.terms_section4_desc': 'Alt innhold, design og teknologi i TipsNorge er eid av TipsNorge eller våre lisensgivere. Bilder du laster opp forblir din eiendom, men du gir oss en begrenset lisens til å bruke dem for å behandle din sak.',
        'legal.terms_section5_title': 'Kontotilgang og opphør',
        'legal.terms_section5_desc': 'Vi forbeholder oss retten til å suspendere eller slette kontoer som bryter disse vilkårene. Du kan når som helst slette din konto via Profil-siden, noe som permanent fjerner alle dine personopplysninger.',
        'legal.terms_section6_title': 'Gjeldende lov og tvister',
        'legal.terms_section6_desc': 'Disse vilkårene er underlagt norsk lov. Eventuelle tvister skal forsøkes løst gjennom dialog, og deretter gjennom Oslo tingrett som første instans.',
        'legal.terms_section7_title': 'Endringer i vilkårene',
        'legal.terms_section7_desc': 'Vi kan oppdatere disse vilkårene fra tid til annen. Vesentlige endringer varsles via e-post til registrerte brukere eller via en melding i appen minst 30 dager i forveien.',
        'legal.terms_contact_title': 'Har du spørsmål?',
        'legal.terms_contact_desc': 'Kontakt oss dersom du har spørsmål om våre vilkår.',

        'admin.suffix': 'Admin',
        'admin.limited_access_title': 'Dashbordtilgang venter',
        'admin.limited_access_desc': 'Din kommune eller myndighet har ennå ikke fullført avtalen for full tilgang til dashbordet. Du vil fortsette å motta detaljerte e-postvarsler for alle nye saker som tildeles din myndighet.',
        'admin.request_access_btn': 'Send forespørsel om tilgang',

        'settings.title': 'Innstillinger',
        'settings.dark_mode': 'Mørk modus',
        'settings.notifications': 'Varslinger',
        'settings.push_notifications': 'Push-varsler',
        'settings.email_notifications': 'E-postvarsler',
        'settings.font_size': 'Skriftstørrelse',
        'settings.font_normal': 'Normal',
        'settings.font_large': 'Stor',
        'settings.font_extra_large': 'Ekstra stor',
        'settings.language': 'Språk',
        'settings.save_error': 'Kunne ikke lagre innstillinger',
        'settings.rate_limit': 'Saker per time',
        'settings.rate_limit_desc': 'Maksimalt antall saker en enkelt bruker kan sende per time.',
        'settings.tab_general': 'Generelt',
        'settings.tab_announcements': 'Kunngjøringer',
        'settings.active': 'Aktiv',
        'settings.inactive': 'Inaktiv',
        'settings.anonymous_reporting': 'Anonym rapportering',
        'settings.anonymous_reporting_desc': 'Tillat brukere å sende inn saker uten å avsløre sin identitet til myndigheten (administratorer ser fortsatt identiteten).',
        'settings.enable_magic_links': 'Aktiver magiske lenker',
        'settings.enable_vipps': 'Aktiver Vipps-innlogging',
        'settings.enable_vipps_desc': 'Vis Vipps som et alternativ på påloggingssiden.',
        'settings.enable_bankid': 'Aktiver BankID-innlogging',
        'settings.enable_bankid_desc': 'Vis BankID som et alternativ på påloggingssiden.',
        'settings.enable_google': 'Aktiver Google-innlogging',
        'settings.enable_google_desc': 'Tillat brukere å logge inn med Google.',
        'settings.enable_email_password': 'Aktiver E-post/Passord',
        'settings.enable_email_password_desc': 'Tillat brukere å logge inn med e-post og passord.',
        'settings.enable_magic_links_desc': 'Tillat myndigheter å løse saker via e-post uten innlogging.',
        'settings.token_validity': 'Gyldighet for token (timer)',
        'settings.banner_type': 'Type',
        'settings.banner_message': 'Melding',
        'settings.banner_placeholder': 'Skriv inn kunngjøringsmelding...',
        'settings.tutorial_mode': 'Opplæringsmodus (Tutorial)',
        'settings.tutorial_desc': 'Velg når opplæringsvinduet skal vises for brukere.',
        'settings.tutorial_new_user': 'Kun nye brukere',
        'settings.tutorial_new_user_desc': 'Én gang per enhet',
        'settings.tutorial_every_session': 'Hver økt',
        'settings.tutorial_every_session_desc': 'Én gang per besøk',
        'settings.tutorial_every_time': 'Hver gang',
        'settings.tutorial_every_time_desc': 'Ved hver sideoppfriskning',
        'settings.tutorial_off': 'Deaktivert',
        'settings.tutorial_off_desc': 'Vises aldri',
        'settings.announcements_desc': 'Konfigurer globale kunngjøringer som vises på den offentlige nettsiden og admin-dashboardet.',
        'settings.public_banner': 'Offentlig nettstedsbanner',
        'settings.admin_banner': 'Admin-dashboardbanner',
        'login.placeholder_municipality': 'f.eks. Oslo Kommune',
        'login.placeholder_contact_person': 'Navn på leder/kontakt',
        'login.placeholder_contact_info': 'Tlf eller e-post',
        'portal.subtitle': 'Saksbehandler-innlogging',
        'portal.admin_login': 'Administrator-innlogging',
        'portal.request_access': 'Mangler tilgang? Ta kontakt!',
        'portal.auth_only': 'Kun for autorisert personell',

        'about.title': 'Om TipsNorge',
        'about.mission_desc': 'TipsNorge forenkler kommunikasjonen mellom innbyggere og kommuner. Vårt mål er å gjøre det enklere å melde fra om problemer, og raskere for myndighetene å fikse dem.',
        'about.how_it_works': 'Hvordan fungerer det?',
        'about.step1': 'Oppdag',
        'about.step1_desc': 'Du ser et problem i ditt lokalmiljø, som hull i veien eller forsøpling.',
        'about.step2': 'Meld fra',
        'about.step2_desc': 'Ta et bilde, bekreft posisjonen, og send inn saken via appen.',
        'about.step3': 'Løst',
        'about.step3_desc': 'Ansvarlig myndighet mottar varselet og fikser problemet.',
        'about.values_title': 'Våre Verdier',
        'about.values_desc': 'Vi bygger teknologi for et bedre samfunn, med fokus på åpenhet og effektivitet.',
        'about.value1_title': 'Personvern',
        'about.value1_desc': 'Vi beskytter dine data og anonymiserer der det er nødvendig.',
        'about.value2_title': 'Effektivitet',
        'about.value2_desc': 'Raskere saksbehandling gjennom automatisk delegering.',
        'about.value3_title': 'Fellesskap',
        'about.value3_desc': 'Sammen skaper vi tryggere og renere nabolag.',
        'about.stat_resolved': 'Saker løst',
        'about.stat_municipalities': 'Kommuner',
        'about.stat_users': 'Aktive brukere',
        'about.cta_title': 'Klar til å bidra?',
        'about.cta_btn': 'Send en sak',

        'contact.support_badge': 'Kundestøtte',
        'contact.title': 'Kontakt Oss',
        'contact.subtitle': 'Vi er her for å hjelpe deg med tekniske problemer eller spørsmål om tjenesten.',
        'contact.email_label': 'E-post',
        'contact.email_desc': 'Vi svarer vanligvis innen 24 timer.',
        'contact.faq_title': 'Ofte stilte spørsmål',
        'contact.faq_desc': 'Sjekk om vi allerede har svart på spørsmålet ditt i hjelpesenteret.',
        'contact.name': 'Navn',
        'contact.name_placeholder': 'Ditt fulle navn',
        'contact.email': 'E-post',
        'contact.email_placeholder': 'din@epost.no',
        'contact.subject': 'Emne',
        'contact.subject_general': 'Generelle spørsmål',
        'contact.subject_tech': 'Tekniske problemer',
        'contact.subject_feedback': 'Tilbakemelding',
        'contact.subject_access': 'Myndighetstilgang',
        'contact.message': 'Melding',
        'contact.send': 'Send melding',
        'contact.error': 'Kunne ikke sende meldingen. Prøv igjen.',
        'contact.success': 'Melding sendt!',
        'contact.success_desc': 'Vi har mottatt meldingen din og svarer deg så snart som mulig.',
        'contact.new_btn': 'Send en ny melding',

        // Home
        'home.title': 'Ser du noe som bør fikses?',
        'home.subtitle': 'Meld fra om hull i veien, søppel, eller andre problemer i ditt nærområde.',
        'home.new_report': 'Ny sak',
        'home.admin_login': 'Logg inn (Kommune)',
        'home.map_title': 'Kartoversikt over saker i nærheten',
        'home.track_link': 'Spor sak',

        'track.invalid_id': 'Ugyldig ID',
        'track.assigned_authority': 'Tildelt myndighet',
        'track.privacy_notice': 'Bilder er skjult av personvernshensyn og er kun synlige for autorisert personell.',
        'track.back_to_feed': 'Tilbake til oversikt',
        'track.enter_id_prompt': 'Skriv inn saksnummeret ovenfor for å se status.',
        'track.timeline_title': 'Saksgang',
        'track.timeline_empty': 'Ingen oppdateringer ennå.',
        'track.timeline_status': 'Status endret til',
        'track.timeline_update': 'Oppdatering',

        // Report
        'report.title': 'Ny sak',
        'report.step1': 'Bilde',
        'report.step2': 'Lokasjon',
        'report.step3': 'Beskrivelse',
        'report.step4': 'Kontakt',
        'report.camera_placeholder': 'Ta bilde av problemet',
        'report.open_camera': 'Åpne kamera',
        'report.analyzing': 'Analyserer bilde...',
        'report.privacy_warning': 'Vennligst unngå å ta bilder av personer eller bilskilt.',
        'report.location_error': 'Kunne ikke hente posisjon',
        'report.fetch_position': 'Hent posisjon',
        'report.gallery': 'Galleri',
        'report.locating': 'Finner din posisjon...',
        'report.location_found': 'Posisjon funnet',
        'report.location_unavailable': 'Posisjon utilgjengelig',
        'report.retry': 'Prøv igjen',
        'report.retry_manual': 'Eller skriv inn adresse manuelt',
        'report.enter_address': 'Skriv inn adresse...',
        'report.use_address': 'Bruk denne adressen',
        'report.searching_address': 'Søker...',
        'report.address_not_found': 'Fant ikke adressen',
        'report.description_placeholder': 'Beskriv hva du ser...',
        'report.sending': 'Sender...',
        'report.submit_btn': 'Send sak',
        'report.error_photo': 'Vennligst ta et bilde først.',
        'report.rate_limit_error': 'For mange saker fra denne enheten. Vennligst prøv igjen senere.',
        'report.error_submission': 'Kunne ikke sende saken. Prøv igjen.',
        'report.camera_access_error': 'Kunne ikke åpne kamera. Vennligst bruk opplastingsknappen i stedet.',
        'report.analyzing_ai': 'Analyserer...',
        'report.ai_suggested': 'AI-forslag',
        'report.ai_high_confidence': 'Høy sikkerhet',
        'report.ai_authority_suggestion': 'Foreslått myndighet',
        'report.auto_describe': 'Auto-beskriv med AI',
        'report.object_label': 'Hva og hvor',
        'report.scene_label': 'Situasjon og konsekvens',
        'report.object_placeholder': 'Beskriv objektet eller stedet (f.eks. hull i veien, knekt skilt, overfylt søppelkasse)',
        'report.scene_placeholder': 'Hva er problemet, og hvorfor bør det følges opp?',
        'report.reporter_info': 'Kontaktinformasjon',
        'report.login_suggest': 'Logg inn',
        'report.login_benefit_text': 'Logg inn for å melde inn sak, sjekke status, varsler og dialog med myndighetene',
        'report.name_label': 'Ditt Navn',
        'report.anonymous': 'Ola eller Kari Normann',
        'report.phone_label': 'Telefonnummer',
        'report.phone_placeholder': '+47 987 65 432',
        'report.category_label': 'Kategori',
        'report.select_category': '-- Velg kategori --',
        'report.review_title': 'Se over saken',
        'report.review_btn': 'Gå videre',
        'report.review_tip': 'Du får mulighet til å se over detaljene før du sender inn.',
        'report.confirm_btn': 'Send inn sak',
        'report.edit_btn': 'Rediger',
        'report.summary_image': 'Bildevisning',
        'report.summary_location': 'Lokasjon',
        'report.summary_description': 'Beskrivelse',
        'report.summary_contact': 'Innmelderen',
        'report.recommended': 'Anbefalt',
        'report.validation_title': 'Vennligst sjekk følgende:',
        'report.validation.image_required': 'Vennligst ta eller velg et bilde av problemet.',
        'report.validation.description_min': 'Beskrivelsen må være på minst 3 tegn.',
        'report.validation.description_max': 'Beskrivelsen kan ikke være lengre enn 500 tegn.',
        'report.validation.location_required': 'Vi trenger din posisjon for å vite hvor saken er.',
        'report.validation.phone_invalid': 'Vennligst oppgi et gyldig norsk telefonnummer (8 siffer).',
        'report.consent': 'Jeg bekrefter at opplysningene er riktige så langt jeg kjenner til.',
        'report.submit_anonymously': 'Send inn anonymt',
        'report.anonymous_desc': 'Din kontaktinformasjon vil ikke være synlig for saksbehandler, men administratorer har innsyn ved behov.',

        // Admin Login
        'login.title': 'Saksbehandler-innlogging',
        'login.email': 'E-post',
        'login.password': 'Passord',
        'login.btn': 'Logg inn',
        'login.magic_link': 'Send innloggingslenke',
        'login.magic_link_success': 'Innloggingslenke er sendt til din e-post!',
        'login.or_continue_with': 'Eller fortsett med',
        'login.no_account_yet': 'Har du ikke konto?',
        'login.already_have_account': 'Har du allerede konto?',
        'login.sign_up_now': 'Registrer deg nå',
        'login.login_now': 'Logg inn nå',
        'login.enter_email': 'Skriv inn din e-post',
        'login.error': 'Feil e-post eller passord.',
        'login.staff_only_error': 'Denne innloggingen er kun for ansatte. Innbyggere bør bruke hovedportalen.',
        'login.enter_email_error': 'Vennligst skriv inn din e-post først.',

        // Password Validation
        'auth.password_too_short': 'Passordet må være minst 8 tegn.',
        'auth.password_needs_uppercase': 'Passordet må inneholde minst én stor bokstav.',
        'auth.password_needs_lowercase': 'Passordet må inneholde minst én liten bokstav.',
        'auth.password_needs_number': 'Passordet må inneholde minst ett tall.',

        // Password Strength
        'auth.criteria_length': 'Minst 8 tegn',
        'auth.criteria_uppercase': 'Stor bokstav',
        'auth.criteria_lowercase': 'Liten bokstav',
        'auth.criteria_number': 'Tall',
        'auth.password_strength': 'Passordstyrke:',
        'auth.strength_weak': 'Svakt',
        'auth.strength_fair': 'Middels',
        'auth.strength_good': 'Bra',
        'auth.strength_strong': 'Sterkt 💪',

        'login.reset_link_success': 'Tilbakestillingslenke er sendt! Sjekk din e-post.',
        'login.auth_personnel_only': 'Kun for autorisert personell',
        'login.forgot_password': 'Glemt?',
        'login.sending': 'Sender...',
        'login.success_check_email': 'Sjekk e-posten din for bekreftelseslenke!',
        'login.use_password': 'Bruk passord i stedet',
        'login.use_magic_link': 'Bruk e-postlenke i stedet',
        'login.request_access': 'Mangler tilgang? Ta kontakt!',
        'login.access_form_title': 'Forespørsel om tilgang',
        'login.access_form_desc': 'Fyll ut skjemaet nedenfor for å be om tilgang til dashbordet.',
        'login.municipality': 'Kommune',
        'login.first_name': 'Fornavn',
        'login.last_name': 'Etternavn',
        'login.contact_person': 'Ansvarlig kontakt hos kommune',
        'login.contact_info_responsible': 'Kontaktinfo for ansvarlig (tlf/epost)',
        'login.send_request': 'Send forespørsel',
        'login.request_sent': 'Forespørsel sendt!',
        'login.request_sent_desc': 'Vi har mottatt din forespørsel og kontakter deg snart.',
        'legal.terms_agreement_pre': 'Ved å fortsette godtar du våre',
        'legal.terms_agreement_and': 'og',

        // Admin Dashboard
        'dashboard.title': 'Oversikt',
        'dashboard.logged_in_as': 'Logget inn som',
        'dashboard.logout': 'Logg ut',
        'dashboard.list': 'Liste',
        'dashboard.grid': 'Rutenett',
        'dashboard.map': 'Kart',
        'dashboard.filter': 'Filter',
        'dashboard.all': 'Alle',
        'dashboard.status': 'Status',
        'dashboard.date': 'Dato',
        'dashboard.location': 'Sted',
        'dashboard.description': 'Beskrivelse',
        'dashboard.actions': 'Handlinger',
        'dashboard.view_details': 'Se detaljer',
        'dashboard.no_reports': 'Ingen saker funnet',
        'dashboard.clear_filter': 'Fjern filter',
        'dashboard.unknown': 'Ukjent',
        'dashboard.no_desc': 'Ingen beskrivelse',
        'dashboard.authorities': 'Myndigheter',
        'dashboard.categories': 'Kategorier',
        'dashboard.users': 'Brukere',
        'dashboard.manage_authorities': 'Administrer myndigheter',
        'dashboard.manage_users': 'Administrer brukere',
        'dashboard.load_more': 'Last inn flere',
        'dashboard.exporting': 'Eksporterer...',
        'dashboard.export_selected': 'Eksporter valgte',
        'dashboard.export_success': 'Eksportert!',
        'dashboard.export_error': 'Kunne ikke eksportere saker.',
        'dashboard.search': 'Søk...',
        'dashboard.select_all': 'Velg alle saker',
        'dashboard.sort_by_status': 'Sorter etter status',
        'dashboard.sort_by_date': 'Sorter etter dato',
        'dashboard.sort_by_location': 'Sorter etter sted',
        'dashboard.sort_by_severity': 'Sorter etter alvorlighetsgrad',

        'dashboard.delete_selected': 'Slett valgte',
        'dashboard.delete_confirm': 'Er du sikker på at du vil slette de valgte sakene? Denne handlingen kan ikke angres.',
        'dashboard.my_cases': 'Mine saker',
        'dashboard.unassigned': 'ikke tildelt',
        'dashboard.case_id': 'Saksnr',
        'dashboard.search_placeholder': 'Søk på saksnr (f.eks. TN-2026-X)...',
        'dashboard.no_reports_found': 'Ingen sak funnet med dette nummeret',
        'dashboard.search_error': 'Feil ved søk etter sak',
        'dashboard.documentation': 'Dokumentasjon',
        'dashboard.map_markers': 'Kartmarkører',
        'dashboard.heatmap': 'Varmekart',
        'dashboard.overview': 'Oversikt over saker', // "Overview of cases"

        // Case Detail
        'detail.back': 'Tilbake til oversikt',
        'detail.case_id': 'Saksnr',
        'detail.case_number': 'Sak #',
        'detail.no_image': 'Ingen bilde tilgjengelig',
        'detail.failed_image': 'Kunne ikke laste bilde',
        'detail.open_link': 'Se bilde',
        'detail.delete_case': 'Slett sak',
        'detail.delete_confirm': 'Er du sikker på at du vil slette denne saken? Denne handlingen kan ikke angres.',
        'detail.unknown_location': 'Ukjent sted',
        'detail.no_desc_provided': 'Ingen beskrivelse gitt.',
        'detail.actions': 'Handlinger',
        'detail.mark_resolved': 'Marker som løst',
        'detail.start_processing': 'Start behandling',
        'detail.processing_started': 'Behandling startet',
        'detail.status_updated': 'Status oppdatert!',
        'detail.mark_progress': 'Marker under arbeid',
        'detail.reporter_contact': 'Kontaktinformasjon',
        'detail.email': 'E-post',
        'detail.assigned_authority': 'Tildelt myndighet',
        'detail.select_authority': 'Velg myndighet',
        'detail.phone': 'Telefon',
        'detail.reopen_case': 'Gjenåpne sak',
        'detail.assign_transfer': 'Overfør',
        'detail.transfer_case': 'Overfør sak',
        'detail.wait_external': 'Vent på ekstern',
        'detail.complete_case': 'Fullfør sak (Lukk)',
        'detail.resume_processing': 'Gjenoppta behandling',
        'detail.section_description': 'Saksbeskrivelse',
        'detail.section_classification': 'Klassifisering',
        'detail.not_categorized': 'Ikke kategorisert',
        'detail.dispatch': 'Send til myndighet',
        'detail.dispatched_success': 'Saken er sendt!',
        'detail.assigned_to': 'Tildelt myndighet',
        'detail.handler': 'Saksbehandler',
        'detail.unassigned_handler': 'Ingen personlig saksbehandler valgt',
        'detail.claim_case': 'Tildel meg',
        'detail.claim_success': 'Du har tatt ansvar for saken',
        'detail.claim_error': 'Kunne ikke ta ansvar for saken',
        'detail.report_not_found': 'Sak ikke funnet.',
        'detail.internal_log': 'Intern logg',
        'detail.entries': 'oppføringer',
        'detail.no_updates': 'Ingen oppdateringer ennå',
        'detail.new_update': 'Ny oppdatering',
        'detail.internal_note': 'Internt notat',
        'detail.update_placeholder': 'Skriv en oppdatering eller kommentar...',
        'detail.unassigned_authority': 'Ingen myndighet tildelt',
        'detail.status_changed': 'Status endret',
        'detail.severity_match': 'Alvorlighetsgrad',
        'detail.severity_changed': 'Alvorlighetsgrad endret til',
        'detail.category_changed': 'Kategori endret til',
        'detail.save_changes': 'Lagre endringer',
        'detail.updated': 'Oppdatert!',
        'detail.dispatch_helper': 'Velg en myndighet som skal håndtere denne saken. Dette vil varsle dem og gi dem tilgang.',
        'detail.transfer_reason': 'Årsak til overføring',
        'detail.transfer_reason_placeholder': 'Begrunnelse for overføring...',
        'detail.assign_to_authority': 'Tildel til myndighet',
        'detail.select_target_authority': 'Velg mottaker for saken',
        'detail.search_authority': 'Søk etter myndighet...',
        'detail.reason_label': 'Begrunnelse for tildeling',
        'detail.confirm_assignment': 'Bekreft tildeling',
        'detail.dispatched_to': 'Sendt til:',
        'detail.update_success': 'Oppdatering postet!',
        'detail.update_error': 'Kunne ikke poste oppdatering',
        'detail.update_comment': 'Skriv en kommentar...',
        'detail.is_internal': 'Intern (kun for autorisert personell)',
        'detail.post_update': 'Post oppdatering',
        'detail.press_enter': 'Trykk Enter for å publisere',
        'detail.unknown_user': 'Ukjent bruker',
        'detail.resolution_code': 'Årsak / Resultat',
        'detail.resolution_prompt': 'Oppgi løsmingskode (FIXED, DISMISSED, REFERRED, NO_ACTION):',
        'detail.closing_comment': 'Løsningskommentar',
        'detail.closing_comment_placeholder': 'Beskriv løsningen...',
        'detail.confirm_resolution': 'Fullfør',
        'detail.timeline': 'Saksgang',
        'detail.map_view': 'Kartvisning',
        'detail.fetch_auth_error': 'Kunne ikke hente myndighetsdetaljer',
        'detail.email_subject': 'Ny sak tildelt:',
        'detail.email_body': 'En ny sak har blitt tildelt din myndighet.',
        'detail.view_in_portal': 'Se i Admin-portal',
        'detail.access_denied': 'Tilgang nektet',
        'detail.pdf_error': 'Sak tildelt, men kunne ikke generere PDF.',
        'detail.delete_error': 'Feil ved sletting av sak:',
        'detail.delete_success': 'Saken ble slettet',
        'detail.email_best_regards': 'Med vennlig hilsen',
        'detail.email_issue_id': 'Saks-ID',
        'detail.email_status': 'Status',
        'detail.reporter_anonymous': 'Anonym',
        'detail.reporter_anonymous_admin': 'Anonym innsending (Synlig for Admin)',
        'detail.no_contact_info': 'Ingen kontaktinformasjon',
        'action.confirm_title': 'Bekreft handling',
        'action.resolve_confirm': 'Du er i ferd med å markere denne saken som LØST.',
        'action.generic_confirm': 'Vennligst bekreft at du vil fortsette.',
        'action.resolution_label': 'Løsningsmelding (Valgfritt)',
        'action.resolution_placeholder': 'Legg til et notat om løsningen til innbyggeren...',
        'action.timeline_notice': 'Denne oppdateringen vil være synlig i den offentlige saksgangen.',
        'action.confirm_btn': 'Bekreft',
        'action.confirm_resolution': 'Bekreft løsning',
        'action.processing': 'Behandler...',
        'action.success_title': 'Vellykket!',
        'action.success_desc': 'Saken har blitt oppdatert.',
        'action.success_resolved': 'Den er nå markert som løst.',
        'action.reference_id': 'Referanse-ID',
        'action.login_admin': 'Logg inn på Saksbehandlingsportal',
        'action.failed_title': 'Handlingen feilet',
        'action.expired_notice': 'Denne lenken kan være utløpt eller allerede brukt.',
        'action.error_token': 'Manglende sikkerhetstoken.',
        'action.error_generic': 'Systemfeil ved behandling av forespørsel.',
        'action.error_invalid': 'Ugyldig eller utløpt token.',
        'action.link_used_title': 'Lenken er allerede brukt',
        'action.link_used_desc': 'Du har sannsynligvis allerede utført denne handlingen. Du kan logge inn i dashbordet for å sjekke status.',
        'action.go_to_dashboard': 'Gå til Dashbord',

        // Authorities
        'authorities.title': 'Myndigheter',
        'authorities.broadcast_title': 'Send e-post til utvalgte',
        'authorities.broadcast_subtitle': 'Mottakere:',
        'authorities.broadcast_subject': 'Emne',
        'authorities.broadcast_subject_placeholder': 'Eks: Viktig oppdatering om...',
        'authorities.broadcast_message': 'Melding',
        'authorities.broadcast_message_placeholder': 'Skriv meldingen din her...',
        'authorities.broadcast_send': 'Send e-post',
        'authorities.broadcast_validation': 'Vennligst fyll ut emne og melding, og velg minst én mottaker.',
        'authorities.broadcast_success': 'E-post sendt til valgte mottakere.',
        'authorities.send_email': 'Send e-post',
        'authorities.add': 'Legg til myndighet',
        'authorities.create': 'Opprett myndighet',
        'authorities.edit': 'Rediger myndighet',
        'authorities.name': 'Navn',
        'authorities.type': 'Type',
        'authorities.email': 'E-post',
        'authorities.webhook': 'Webhook URL',
        'authorities.status': 'Status',
        'authorities.active': 'Aktiv',
        'authorities.inactive': 'Inaktiv',
        'authorities.actions': 'Handlinger',
        'authorities.no_authorities': 'Ingen myndigheter funnet.',
        'authorities.created_success': 'Myndighet opprettet!',
        'authorities.updated_success': 'Myndighet oppdatert!',
        'authorities.type_municipal': 'Kommunal',
        'authorities.type_road': 'Vei',
        'authorities.type_civil': 'Sivil',
        'authorities.type_private': 'Privat',
        'authorities.contact': 'Kontakt',
        'authorities.active_label': 'Aktiv',
        'authorities.placeholder_name': 'f.eks. Statens vegvesen',
        'authorities.delete_confirm': 'Er du sikker på at du vil slette denne myndigheten?',
        'authorities.selected': 'valgt',
        'authorities.activate_selected': 'Aktiver valgte',
        'authorities.deactivate_selected': 'Deaktiver valgte',
        'authorities.magic_link_enabled': 'Magic Link aktiv',
        'authorities.magic_link_desc': 'Tillat saksbehandling via direkte lenker uten passord.',
        'authorities.token_validity': 'Token gyldighet (timer)',

        // Users
        'users.title': 'Brukere',
        'users.add': 'Legg til bruker',
        'users.tab_admins': 'Administratorer',
        'users.tab_staff': 'Ansatte',
        'users.tab_authorities': 'Saksbehandlere',
        'users.tab_end_users': 'Innbyggere',
        'users.create': 'Opprett bruker',
        'users.edit': 'Rediger bruker',
        'users.name': 'Navn',
        'users.joined': 'Ble med',
        'users.first_name': 'Fornavn',
        'users.last_name': 'Etternavn',
        'users.email': 'E-post',
        'users.password': 'Passord',
        'users.new_password': 'Nytt passord',
        'users.role': 'Rolle',
        'users.authority': 'Myndighet',
        'users.status': 'Status',
        'users.active': 'Aktiv',
        'users.disabled': 'Deaktivert',
        'users.actions': 'Handlinger',
        'users.no_users': 'Ingen brukere funnet.',
        'users.created_success': 'Bruker opprettet!',
        'users.updated_success': 'Bruker oppdatert!',
        'users.password_reset_success': 'Passord tilbakestilt!',
        'users.error_create': 'Feil ved oppretting av bruker',
        'users.error_update': 'Feil ved oppdatering av bruker',
        'users.error_reset_password': 'Feil ved tilbakestilling av passord',
        'users.error_status_update': 'Feil ved oppdatering av status',
        'users.new_password_placeholder': 'Skriv inn nytt passord',
        'users.role_admin': 'Administrator',
        'users.role_authority_user': 'Saksbehandler',
        'users.assign_authority': 'Tildel myndighet',
        'users.select_authority': '-- Velg myndighet --',
        'users.reset_password': 'Tilbakestill passord',
        'users.reset_password_desc': 'Skriv inn nytt passord for',
        'users.enable': 'Aktiver',
        'users.disable': 'Deaktiver',
        'users.confirm_disable': 'Er du sikker på at du vil deaktivere denne brukeren?',
        'users.confirm_enable': 'Er du sikker på at du vil aktivere denne brukeren?',
        'users.managed_via_db': 'Administrert via DB',
        'users.edit_user': 'Rediger bruker',
        'users.save_changes': 'Lagre endringer',
        'users.saving': 'Lagrer...',
        'users.creating': 'Oppretter...',
        'users.inviting': 'Sender invitasjon...',
        'users.send_invitation': 'Send invitasjon',
        'users.resend_invite': 'Send invitasjon på nytt',
        'users.resending': 'Sender på nytt...',
        'users.resetting': 'Tilbakestiller...',
        'users.delete_confirm_title': 'Slett bruker',
        'users.delete_confirm_message': 'Er du sikker på at du vil slette denne brukeren? Denne handlingen kan ikke angres.',
        'setup_password.title': 'Fullfør registrering',
        'setup_password.desc': 'Vennligst velg et sikkert passord for din nye konto.',
        'setup_password.password_label': 'Nytt passord',
        'setup_password.confirm_label': 'Bekreft passord',
        'setup_password.placeholder': 'Minst 8 tegn',
        'setup_password.submit': 'Lagre passord',
        'setup_password.success': 'Passordet er lagret! Du blir nå logget inn.',
        'setup_password.error': 'Kunne ikke lagre passordet. Vennligst prøv igjen.',
        'setup_password.mismatch': 'Passordene er ikke like.',
        'setup_password.invalid_link': 'Ugyldig eller utløpt lenke',
        'setup_password.password_length': 'Passordet må være minst 8 tegn',
        'setup_password.verifying': 'Verifiserer invitasjon...',

        // Statuses
        'status.OPEN': 'ÅPEN',
        'status.IN_PROGRESS': 'PÅGÅR',
        'status.WAITING': 'VENTER',
        'status.RESOLVED': 'LØST',
        'status.ALL': 'Alle',
        'status_desc.OPEN': 'Saken er mottatt',
        'status_desc.IN_PROGRESS': 'Vi jobber med saken',
        'status_desc.RESOLVED': 'Saken er løst',



        'users.role.ADMIN': 'Administrator',
        'users.role.AUTHORITY_USER': 'Saksbehandler',
        'users.role.USER': 'Innbygger',

        'auth_type.MUNICIPAL': 'Kommune',
        'auth_type.ROAD': 'Veivesen',
        'auth_type.CIVIL': 'Sivilforsvar',
        'auth_type.PRIVATE': 'Privat',

        // Offline
        'report.offline_saved': 'Din sak er lagret lokalt. Den vil bli sendt automatisk når du er online igjen.',
        'report.success_title': 'Sak Mottatt!',
        'report.success_desc': 'Takk for at du bidrar til et tryggere samfunn. Din sak er nå registrert.',
        'report.tracking_id': 'Sporings-ID',
        'report.tracking_tip': 'Ta vare på denne ID-en for å sjekke status på din sak senere.',
        'report.track_btn': 'Spor Sak Nå',
        'report.back_home': 'Tilbake til Hjem',
        'report.offline_title': 'Frakoblet modus',
        'report.syncing': 'Synkroniserer saken...',
        'report.get_receipt': 'Få tilsendt kvittering',
        'report.send_receipt': 'Send kvittering',
        'report.receipt_sent': 'Kvittering sendt!',
        'report.receipt_error': 'Kunne ikke sende kvittering. Prøv igjen senere.',
        'report.pick_from_map': 'Velg fra kart',
        'report.confirm_location': 'Bekreft posisjon',
        'report.map_picker_help': 'Klikk i kartet for å velge nøyaktig posisjon',
        'track.title': 'Spor din sak',
        'track.subtitle': 'Skriv inn din sporings-ID for å se siste oppdateringer.',
        'track.placeholder': 'Skriv inn saksnr (TN-2026-X) eller sporings-ID',
        'track.search_placeholder': 'Skriv inn saks-ID (f.eks. TN-2024-001)',
        'track.search_btn': 'Søk',
        'track.not_found': 'Fant ingen sak med denne ID-en. Vennligst sjekk at ID-en er riktig.',
        'track.status_label': 'Nåværende Status',
        'track.details_label': 'Saksdetaljer',
        'track.date_label': 'Innsendt Dato',
        'track.location_label': 'Sted',
        'severity.LOW': 'Lav',
        'severity.MEDIUM': 'Medium',
        'severity.HIGH': 'Høy',
        'severity.CRITICAL': 'Kritisk',
        'dashboard.severity': 'Alvorlighetsgrad',
        'track.category_label': 'Kategori',
        'track.severity_label': 'Alvorlighetsgrad',
        'track.label_object': 'Hva',
        'track.label_scene': 'Situasjon',

        // New Feature Translations (Home Feed)
        'home.recent_activity': 'Siste aktiviteter',
        'home.no_activity': 'Ingen nylig aktivitet.',
        'home.time.just_now': 'Akkurat nå',
        'home.time.min_ago': 'm siden',
        'home.time.hour_ago': 't siden',
        'home.time.day_ago': 'd siden',
        'home.tabs.my_reports': 'Mine saker',
        'home.tabs.community': 'I nærområdet',
        'nav.home': 'Hjem',
        'nav.map': 'Kart',
        'nav.report': 'Meld',
        'nav.my_reports': 'Mine saker',
        'nav.profile': 'Profil',
        'nav.help': 'Hjelp',

        // Profile
        'profile.title': 'Min Profil',
        'profile.my_reports': 'Mine saker',
        'profile.my_reports_desc': 'Her finner du en oversikt over alle saker du har meldt inn.',
        'profile.history_placeholder': 'Historikk kommer snart.',
        'profile.sign_out': 'Logg ut',
        'profile.delete_account': 'Slett min konto & alle mine data',
        'profile.delete_confirm': 'Er du helt sikker? Denne handlingen vil slette alle dine saker og din brukerkonto permanent. Dette kan ikke angres.',
        'profile.deleting': 'Sletter data...',
        'report.redirecting': 'Sender deg til oversikten...',
        'track.not_found_error': 'Fant ingen sak med denne ID-en.',

        // Citizen Login
        'login.citizen_title': 'Logg inn',
        'login.citizen_desc': 'Logg inn for å spore dine saker og administrere din profil.',
        'login.citizen_desc_signup': 'Opprett en konto for å få full oversikt over dine saker.',
        'login.google': 'Fortsett med Google',
        'login.vipps': 'Fortsett med Vipps',
        'login.bankid': 'Logg inn med BankID',
        'login.coming_soon': 'Kommer snart',
        'login.facebook': 'Fortsett med Facebook',
        'login.magic_link_title': 'Logg inn med e-post',
        'login.create_account': 'Ny brukerkonto',
        'login.create_account_btn': 'Opprett konto',
        'login.send_magic_link': 'Send innloggingslenke',
        'login.forgot_password_link': 'Glemt passord?', // Note: I used 'login.forgot_password' in code which maps to 'Glemt?' before. Updating validation.

        // Quick Wins
        'report.scanning': 'Analyserer bilde...',
        'track.rate_fix': 'Hvordan vil du vurdere løsningen?',
        'track.feedback_placeholder': 'Valgfri kommentar til myndighetene...',
        'track.submit_feedback': 'Send vurdering',
        'track.feedback_thank_you': 'Takk for din tilbakemelding!',

        // Cookie Consent
        'cookie.title': 'Vi bruker informasjonskapsler',
        'cookie.desc': 'Vi bruker informasjonskapsler for å sikre at nettstedet fungerer som det skal, samt for å forstå hvordan du bruker tjenesten vår.',
        'cookie.accept_all': 'Godta alle',
        'cookie.reject_all': 'Avvis alle',
        'cookie.preferences': 'Innstillinger',
        'cookie.save': 'Lagre valg',
        'cookie.necessary.title': 'Nødvendige',
        'cookie.necessary.desc': 'Disse er nødvendige for at nettstedet skal fungere, f.eks. for innlogging.',
        'cookie.prefs.title': 'Funksjonelle',
        'cookie.prefs.desc': 'Husk valg som språk og tema.',
        'cookie.stats.title': 'Statistikk',
        'cookie.stats.desc': 'Hjelper oss å forbedre tjenesten ved å samle anonym bruksdata.',

        // Admin Analytics & Map
        'dashboard.analytics': 'Analyse',
        'dashboard.hotspot': 'Hotspot',
        'dashboard.reports_nearby': 'saker i nærheten',
        'analytics.total_reports': 'Totalt antall saker',
        'analytics.avg_rating': 'Snittvurdering',
        'analytics.avg_resolution': 'Snitt løsningstid',
        'analytics.completion_rate': 'Gjennomføringsgrad',
        'analytics.status_distribution': 'Statusfordeling',
        'analytics.community_impact': 'Samfunnseffekt',
        'analytics.hours': 't',
        'analytics.days': 'd',
        'analytics.safety_index': 'Sikkerhetsindeks',
        'analytics.safety_index_desc': 'Basert på løsningstid',
        'analytics.trust_score': 'Tillitsscore',
        'analytics.trust_score_desc': 'Positive tilbakemeldinger',
        'analytics.performance_summary': '"Data indikerer en forbedring i responstid på 15 % siden forrige måned."',

        // Case Detail & Referral
        'detail.refer_case': 'Henvis sak',
        'detail.referral_reason': 'Årsak til henvisning',
        'detail.referral_reason_placeholder': 'Hvorfor sendes denne saken videre?',
        'detail.referral_success': 'Saken er henvist!',
        'detail.no_authority_assigned': 'Ingen myndighet tildelt',
        'detail.assign_now': 'Tildel nå',
        'detail.referral_error': 'Kunne ikke henvise saken.',
        'detail.timeline_internal': 'Intern Logg',
        'detail.timeline_public': 'Delt med Innbygger',
        'nav.notifications': 'Varslinger',
        'nav.no_notifications': 'Ingen nye varsler',
        'audit.referred': 'Sak henvist til ny myndighet',
        'audit.transferred': 'Sak overført til ny myndighet',
        'audit.reason': 'Årsak',
        'audit.reopened_admin': 'Sak gjenåpnet',
        'audit.type_DECISION': 'Beslutning',
        'audit.type_ASSIGNMENT': 'Tildeling',
        'audit.type_EXTERNAL': 'Ekstern',
        'audit.type_CITIZEN': 'Innbygger',
        'audit.type_SYSTEM': 'System',
        'audit.type_INFO': 'Info',
        'track.not_found_title': 'Fant ikke saken',
        'track.municipality_label': 'Kommune',
        'track.authority_label': 'Ansvarlig myndighet',
        'track.update_label': 'Oppdatering',
        'track.feedback_satisfied': 'Hvor fornøyd er du med løsningen?',
        'track.submitting': 'Sender...',
        'track.unknown': 'Ukjent',
        'track.general': 'Generelt',
        'track.evidence_alt': 'Bevis',
        'track.no_reports_desc': 'Du har ikke sendt inn noen tips enda. Hjelp oss å holde nærmiljøet trygt.',
        'detail.section_authority': 'Tildelt Myndighet',
        'detail.section_reporter': 'Rapportert av',

        // Help Center
        'help.title': 'Hvordan kan vi hjelpe deg?',
        'help.subtitle': 'Søk i våre guider eller kontakt support',
        'help.guide_title': 'Slik bruker du TipsNorge',
        'help.step1_title': 'Ta et bilde',
        'help.step1_desc': 'Knips et bilde av problemet (f.eks. et hull i veien).',
        'help.step2_title': 'Kontroller/Velg posisjon',
        'help.step2_desc': 'Kartet finner automatisk hvor du er.',
        'help.step3_title': 'Kontroller og send inn',
        'help.step3_desc': 'Vi sender saken direkte til rett etat.',
        'help.search_placeholder': 'Søk etter svar...',
        'help.step1_detail': 'Åpne appen og trykk "Ny sak". Kameraet aktiveres automatisk. Ta et tydelig bilde av problemet — unngå å fotografere personer eller bilskilt.',
        'help.step2_detail': 'GPS finner automatisk din posisjon. Hvis plasseringen er feil, kan du dra kartnålen til riktig sted. AI analyserer bildet og foreslår beskrivelse.',
        'help.step3_detail': 'Bekreft informasjonen og trykk "Send inn". Du mottar en sporings-ID umiddelbart som du kan bruke til å følge sakens status.',

        // Help Topics
        'help.topic.reporting': 'Sende rapport',
        'help.topic.reporting.q1': 'Hvordan sender jeg inn en sak?',
        'help.topic.reporting.a1': 'Trykk "Ny sak" på forsiden, ta et bilde, bekreft posisjonen og trykk send. Det tar under ett minutt.',
        'help.topic.reporting.q2': 'Kan jeg legge ved flere bilder?',
        'help.topic.reporting.q3': 'Hva skjer etter at jeg sender inn?',
        'help.topic.reporting.a3': 'Saken sendes automatisk til riktig myndighet basert på kategori og plassering. Du kan følge status med sporings-ID.',
        'help.topic.tracking': 'Spore saker',
        'help.topic.tracking.q1': 'Hvordan sporer jeg en innsendt sak?',
        'help.topic.tracking.a1': 'Gå til "Mine saker" i menyen, eller bruk sporings-ID-en du fikk ved innsending til å søke opp saken.',
        'help.topic.tracking.q2': 'Hva betyr de ulike statusene?',
        'help.topic.tracking.a2': 'ÅPEN = mottatt og venter, PÅGÅR = myndigheten jobber med saken, LØST = problemet er fikset.',
        'help.topic.account': 'Min profil',
        'help.topic.account.q1': 'Må jeg opprette en konto?',
        'help.topic.account.a1': 'Ja, du må logge inn for å sende saker. Dette sikrer kvaliteten på tjenesten. Du kan likevel velge å være anonym.',
        'help.topic.account.q2': 'Hvordan logger jeg inn?',
        'help.topic.account.a2': 'Du kan logge inn med Google, Magic Link (e-post) eller e-post og passord.',
        'help.topic.privacy': 'Personvern',
        'help.topic.privacy.q1': 'Er sakene mine anonyme?',
        'help.topic.privacy.a1': 'Ja, du kan velge å sende inn anonymt selv om du er logget inn. Din identitet vil være skjult for saksbehandler.',
        'help.topic.privacy.q2': 'Hvordan slettes mine data?',
        'help.topic.privacy.a2': 'Gå til Profil > Slett min konto. All personlig data slettes permanent. Anonymisert statistikk beholdes.',

        'help.faq_title': 'Ofte stilte spørsmål',
        'help.contact_title': 'Finner du ikke svaret?',
        'help.contact_desc': 'Ta kontakt med vårt support-team.',
        'help.contact_btn': 'Kontakt oss',
        'help.category.general': 'Generelt',
        'help.category.technical': 'Teknisk',
        'help.category.privacy': 'Personvern',
        'help.faq.q1': 'Er TipsNorge gratis å bruke?',
        'help.faq.a1': 'Ja, TipsNorge er en gratis tjeneste for alle innbyggere.',
        'help.faq.q2': 'Hvem mottar sakene mine?',
        'help.faq.a2': 'Sakene sendes automatisk til ansvarlig myndighet basert på kategori og geolokasjon.',
        'help.faq.q3': 'Kan jeg være anonym?',
        'help.faq.a3': 'Ja, du kan velge å ikke oppgi navn. Men myndighetene kan da ikke kontakte deg for oppfølging.',
        'help.faq.q4': 'Hvordan sletter jeg brukeren min?',
        'help.faq.a4': 'Gå til Profil > Slett min konto. Dette sletter all data permanent.',
        'help.faq.q5': 'Hva skjer hvis jeg er offline?',
        'help.faq.a5': 'Rapporten lagres lokalt og sendes automatisk når du er tilkoblet igjen.',
        'help.faq.q6': 'Appen finner ikke posisjonen min',
        'help.faq.a6': 'Sjekk at du har tillatt stedsdata i nettleserinnstillingene. iPhone: Innstillinger > Personvern > Stedstjenester. Android: Innstillinger > Plassering.',
        'help.faq.q7': 'Hvor lang tid tar det å fikse problemet?',
        'help.faq.a7': 'Dette varierer. Kritiske problemer prioriteres innen 24-48 timer, kosmetiske saker planlegges inn i vedlikeholdsrunder.',
        'help.faq.q8': 'Hvem kan se bildene mine?',
        'help.faq.a8': 'Bilder er kun synlige for myndigheten som behandler saken. De vises aldri offentlig med kobling til din identitet.',



        // Support System
        'support.title': 'Kundestøtte',
        'support.new_ticket': 'Ny henvendelse',
        'support.subject_placeholder': 'Hva gjelder det?',
        'support.message_placeholder': 'Beskriv ditt problem eller spørsmål...',
        'support.priority': 'Prioritet',
        'support.priority.NORMAL': 'Normal',
        'support.priority.HIGH': 'Høy',
        'support.status.OPEN': 'Åpen',
        'support.status.IN_PROGRESS': 'Under behandling',
        'support.status.CLOSED': 'Lukket',
        'support.no_tickets': 'Ingen aktive henvendelser.',
        'support.created_at': 'Opprettet',
        'support.admin_inbox': 'Admin Innboks',
        'support.all_tickets': 'Alle henvendelser',
        'support.respond': 'Gi tilbakemelding',
        'support.respond_email': 'Svar på e-post',
        'support.admin_response': 'Svar fra administrator',
        'support.response_placeholder': 'Skriv ditt svar her...',
        'support.resolve_btn': 'Løs og send svar',
        'support.update_btn': 'Oppdater med svar',
        'support.response_required': 'Vennligst skriv et svar før du fortsetter',
        'support.delete_confirm': 'Er du sikker på at du vil slette denne henvendelsen?',

        // System Settings
        'settings.system': 'Systeminnstillinger',
        'settings.allow_guest': 'Tillat innsending som gjest',
        'settings.allow_guest_desc': 'Hvis deaktivert, kan kun innloggede brukere sende inn saker.',
        'report.guest_restricted': 'Innsending som gjest er for øyeblikket deaktivert.',
        'report.login_required': 'Vennligst logg inn for å sende en sak.',

        'error.boundary_title': 'Noe gikk galt',
        'error.boundary_desc': 'Vi beklager! En uventet feil oppstod. Vennligst prøv igjen.',
        'error.tech_details': 'Tekniske detaljer',
        'error.reload_btn': 'Last inn siden på nytt',
        'error.go_home': 'Gå til forsiden',
        'error.support_hint': 'Hvis problemet vedvarer, vennligst kontakt support.',
        'error.no_location': 'Ingen lokasjonsdata tilgjengelig',
        'error.connection_title': 'Tilkoblingsfeil',
        'error.profile_load_fail': 'Vi klarte ikke å laste din brukerprofil. Dette kan skyldes nettverksproblemer.',

        // Sharing
        'share.title': 'Del TipsNorge',
        'share.subtitle': 'Hjelp oss å gjøre nabolaget bedre ved å invitere venner og familie.',
        'share.btn': 'Del med andre',
        'share.copy': 'Kopier lenke',
        'share.copied': 'Lenke kopiert!',
        'share.whatsapp': 'WhatsApp',
        'share.messenger': 'Messenger',
        'share.sms': 'SMS',
        'share.native': 'Del...',
        'share.message': 'Jeg bruker TipsNorge for å gjøre nabolaget vårt bedre! Sjekk det ut her: ',
    },
    en: {
        // Common
        'app.name': 'TipsNorge',
        'loading': 'Loading...',
        'error': 'An error occurred',
        'submit': 'Submit',
        'cancel': 'Cancel',
        'common.unnamed': 'Unnamed User',
        'common.syncing': 'Syncing',
        'common.offline': 'Offline',
        'common.sending': 'Sending...',
        'common.loading': 'Loading...',
        'common.load_more': 'Load more',
        'common.version': 'Version',
        'common.share': 'Share',
        'common.or': 'or',
        'common.link_copied': 'Link copied to clipboard',
        'common.name_label': 'Name:',
        'common.phone_label': 'Phone:',
        'back': 'Back',
        'save': 'Save',
        'create': 'Create',
        'edit': 'Edit',
        'delete': 'Delete',
        'close': 'Close',
        'confirm': 'Confirm',
        'yes': 'Yes',
        'no': 'No',
        'legal.terms': 'Terms of Service',
        'legal.privacy': 'Privacy Policy',
        'legal.copyright': '© 2026 TipsNorge. All rights reserved.',
        'legal.last_updated': 'Last updated',
        'legal.privacy_title': 'Privacy Policy',
        'legal.privacy_intro': 'TipsNorge processes data in accordance with GDPR and Norwegian data protection laws. We only collect information necessary to process your reports.',
        'legal.privacy_section1_title': '1. What data do we collect?',
        'legal.privacy_section1_desc': 'We collect the following data to provide our service:',
        'legal.privacy_data_location': 'Location data (GPS coordinates) to identify where the issue is located.',
        'legal.privacy_data_images': 'Images for documentation. Images are analyzed by AI but stored securely.',
        'legal.privacy_data_contact': 'Contact information such as email if you choose to register an account.',
        'legal.privacy_section2_title': '2. Purpose of processing',
        'legal.privacy_section2_desc': 'The primary purpose is to convey information about defects and issues to the relevant authority (municipality, county, or state) for infrastructure repair.',
        'legal.privacy_section3_title': '3. Data Security',
        'legal.privacy_section3_desc': 'We use modern encryption and secure servers provided by Supabase to protect your data from unauthorized access.',
        'legal.privacy_section4_title': '4. Your Rights',
        'legal.privacy_section4_desc': 'You have the right to access your information, as well as the right to request deletion or correction of incomplete data. You can delete your account and all associated data directly from your profile page.',

        'legal.terms_title': 'Terms of Service',
        'legal.terms_date': 'January 19, 2026',
        'legal.terms_intro': 'By using TipsNorge, you accept these terms of service. The service is provided "as is" to simplify reporting of infrastructure issues to Norwegian authorities.',
        'legal.terms_section1_title': '1. Use of the Service',
        'legal.terms_section1_desc': 'You agree to use the service in a responsible manner:',
        'legal.terms_rule1': 'Only report real problems in public spaces.',
        'legal.terms_rule2': 'Do not include personal information or irrelevant info in reports.',
        'legal.terms_rule3': 'Do not use the service for harassment, spam, or sabotage.',
        'legal.terms_section2_title': '2. Image Usage',
        'legal.terms_section2_desc': 'By uploading images, you confirm that you have the right to share the image. Avoid taking photos of faces or license plates to protect third-party privacy.',
        'legal.terms_section3_title': '3. Limitation of Liability',
        'legal.terms_section3_desc': 'TipsNorge is a communication platform. We do not guarantee that all reports will be repaired, as this depends on the priorities of each individual authority.',
        'legal.terms_section4_title': '4. Intellectual Property',
        'legal.terms_section4_desc': 'All content, design, and technology in TipsNorge is owned by TipsNorge or our licensors. Images you upload remain your property, but you grant us a limited license to use them for processing your report.',
        'legal.terms_section5_title': '5. Account Access and Termination',
        'legal.terms_section5_desc': 'We reserve the right to suspend or delete accounts that violate these terms. You may delete your account at any time via the Profile page, which permanently removes all your personal data.',
        'legal.terms_section6_title': '6. Governing Law and Disputes',
        'legal.terms_section6_desc': 'These terms are governed by Norwegian law. Any disputes shall first be attempted resolved through dialogue, and then through Oslo District Court as the first instance.',
        'legal.terms_section7_title': '7. Changes to Terms',
        'legal.terms_section7_desc': 'We may update these terms from time to time. Significant changes will be communicated via email to registered users or through a notification in the app at least 30 days in advance.',
        'legal.terms_contact_title': 'Have questions?',
        'legal.terms_contact_desc': 'Contact us at support@tipsnorge.no if you have questions about our terms.',

        'admin.suffix': 'Admin',
        'admin.limited_access_title': 'Dashboard Access Pending',
        'admin.limited_access_desc': 'Your municipality or authority has not yet completed the agreement for full dashboard access. You will continue to receive detailed email notifications for all new cases assigned to your authority.',
        'admin.request_access_btn': 'Request access',

        'settings.title': 'Settings',
        'settings.dark_mode': 'Dark Mode',
        'settings.notifications': 'Notifications',
        'settings.push_notifications': 'Push Notifications',
        'settings.email_notifications': 'Email Notifications',
        'settings.font_size': 'Font Size',
        'settings.font_normal': 'Normal',
        'settings.font_large': 'Large',
        'settings.font_extra_large': 'Extra Large',
        'settings.language': 'Language',
        'settings.save_error': 'Failed to save settings',
        'settings.rate_limit': 'Reports per Hour',
        'settings.rate_limit_desc': 'Maximum number of reports a single user can submit per hour.',
        'settings.tab_general': 'General',
        'settings.tab_announcements': 'Announcements',
        'settings.active': 'Active',
        'settings.inactive': 'Inactive',
        'settings.anonymous_reporting': 'Anonymous Reporting',
        'settings.anonymous_reporting_desc': 'Allow users to submit reports without revealing their identity to the authority (admins still see identity).',
        'settings.enable_magic_links': 'Enable Magic Links',
        'settings.enable_magic_links_desc': 'Allow authorities to resolve issues via email without login.',
        'settings.token_validity': 'Token Validity (Hours)',
        'settings.banner_type': 'Type',
        'settings.banner_message': 'Message',
        'settings.banner_placeholder': 'Enter announcement message...',
        'settings.tutorial_mode': 'Tutorial Mode',
        'settings.tutorial_desc': 'Choose when the tutorial popup appears for users.',
        'settings.tutorial_new_user': 'New Users Only',
        'settings.tutorial_new_user_desc': 'Once per device',
        'settings.tutorial_every_session': 'Every Session',
        'settings.tutorial_every_session_desc': 'Once per visit',
        'settings.tutorial_every_time': 'Every Time',
        'settings.tutorial_every_time_desc': 'On every page refresh',
        'settings.tutorial_off': 'Disabled',
        'settings.tutorial_off_desc': 'Never show',
        'settings.announcements_desc': 'Configure global announcements appearing on the public site and admin dashboard.',
        'settings.public_banner': 'Public Website Banner',
        'settings.admin_banner': 'Admin Dashboard Banner',
        'login.placeholder_municipality': 'e.g. Oslo Municipality',
        'login.placeholder_contact_person': 'Manager/contact name',
        'login.placeholder_contact_info': 'Phone or email',
        'portal.subtitle': 'Municipality Portal',
        'portal.admin_login': 'Administrator login',

        'about.title': 'About TipsNorge',
        'about.mission_desc': 'TipsNorge simplifies communication between citizens and municipalities. Our goal is to make reporting easier and fixing faster.',
        'about.how_it_works': 'How it works',
        'about.step1': 'Discover',
        'about.step1_desc': 'You spot an issue in your local community, like a pothole or litter.',
        'about.step2': 'Report',
        'about.step2_desc': 'Take a photo, confirm location, and submit via the app.',
        'about.step3': 'Resolved',
        'about.step3_desc': 'The responsible authority receives the alert and fixes the issue.',
        'about.values_title': 'Our Values',
        'about.values_desc': 'Building technology for a better society, focused on transparency and efficiency.',
        'about.value1_title': 'Privacy',
        'about.value1_desc': 'We protect your data and anonymize where necessary.',
        'about.value2_title': 'Efficiency',
        'about.value2_desc': 'Faster case handling through automatic delegation.',
        'about.value3_title': 'Community',
        'about.value3_desc': 'Creating safer and cleaner neighborhoods together.',
        'about.stat_resolved': 'Cases resolved',
        'about.stat_municipalities': 'Municipalities',
        'about.stat_users': 'Active users',
        'about.cta_title': 'Ready to contribute?',
        'about.cta_btn': 'Submit a Report',

        'contact.support_badge': 'Support',
        'contact.title': 'Contact Us',
        'contact.subtitle': 'We are here to help with technical issues or questions about the service.',
        'contact.email_label': 'Email',
        'contact.email_desc': 'We usually respond within 24 hours.',
        'contact.faq_title': 'FAQ',
        'contact.faq_desc': 'Check if we have already answered your question in the help center.',
        'contact.name': 'Name',
        'contact.name_placeholder': 'Your full name',
        'contact.email': 'Email',
        'contact.email_placeholder': 'your@email.com',
        'contact.subject': 'Subject',
        'contact.subject_general': 'General Inquiry',
        'contact.subject_tech': 'Technical Issue',
        'contact.subject_feedback': 'Feedback',
        'contact.subject_access': 'Authority Access',
        'contact.message': 'Message',
        'contact.send': 'Send Message',
        'contact.check_faq': 'Before sending a message:',
        'contact.check_faq_link': 'Check if the answer is in the Help Center',
        'about.ready_to_contribute': 'Ready to contribute?',
        'legal.privacy_contact_title': 'Data Protection Officer',
        'legal.privacy_contact_desc': 'For privacy questions, contact us directly at:',
        'contact.error': 'Failed to send message. Please try again.',
        'contact.success': 'Message Sent!',
        'contact.success_desc': 'We have received your message and will respond as soon as possible.',
        'contact.new_btn': 'Send a new message',

        // Home
        'home.title': 'See something that needs fixing?',
        'home.subtitle': 'Report potholes, trash, or other issues in your neighborhood.',
        'home.new_report': 'New Report',

        // Help Center
        'help.title': 'How can we help you?',
        'help.subtitle': 'Search guides or contact support',
        'help.guide_title': 'How to use TipsNorge',
        'help.step1_title': 'Take a photo',
        'help.step1_desc': 'Snap a picture of the issue (e.g., a pothole).',
        'help.step2_title': 'Select location',
        'help.step2_desc': 'The map automatically finds your spot.',
        'help.step3_title': 'Submit',
        'help.step3_desc': 'We route the report to the right authority.',
        'help.search_placeholder': 'Search for answers...',
        'help.step1_detail': 'Open the app and tap "New Report". The camera opens automatically. Take a clear photo of the issue — avoid photographing people or license plates.',
        'help.step2_detail': 'GPS automatically detects your position. If the pin is wrong, drag it to the correct spot. AI analyzes the image and suggests a description.',
        'help.step3_detail': 'Confirm the information and tap "Submit". You\'ll receive a tracking ID immediately that you can use to follow your report\'s progress.',

        // Help Topics
        'help.topic.reporting': 'Submit a report',
        'help.topic.reporting.q1': 'How do I submit a report?',
        'help.topic.reporting.a1': 'Tap "New Report" on the home page, take a photo, confirm the location and tap submit. It takes less than a minute.',
        'help.topic.reporting.q2': 'Can I attach multiple photos?',
        'help.topic.reporting.a2': 'Currently we support one photo per report. Take the photo that best shows the problem.',
        'help.topic.reporting.q3': 'What happens after I submit?',
        'help.topic.reporting.a3': 'Your report is automatically routed to the right authority based on category and location. You can track its status with the tracking ID.',
        'help.topic.tracking': 'Track reports',
        'help.topic.tracking.q1': 'How do I track a submitted report?',
        'help.topic.tracking.a1': 'Go to "My Reports" in the menu, or use the tracking ID you received on submission to look up the case.',
        'help.topic.tracking.q2': 'What do the different statuses mean?',
        'help.topic.tracking.a2': 'OPEN = received and waiting, IN PROGRESS = authority is working on it, RESOLVED = issue is fixed.',
        'help.topic.account': 'My profile',
        'help.topic.account.q1': 'Do I need to create an account?',
        'help.topic.account.a1': 'No, you can submit reports as a guest. But an account gives you access to history and updates.',
        'help.topic.account.q2': 'How do I sign in?',
        'help.topic.account.a2': 'You can sign in with Google, Magic Link (email), or email and password.',
        'help.topic.privacy': 'Privacy',
        'help.topic.privacy.q1': 'Are my reports anonymous?',
        'help.topic.privacy.a1': 'Yes, you can submit completely anonymously as a guest. Registered users share their name with the authority, but it\'s never shown publicly.',
        'help.topic.privacy.q2': 'How is my data deleted?',
        'help.topic.privacy.a2': 'Go to Profile > Delete my account. All personal data is permanently deleted. Anonymized statistics are retained.',

        'help.faq_title': 'Frequently Asked Questions',
        'help.contact_title': 'Can\'t find the answer?',
        'help.contact_desc': 'Contact our support team.',
        'help.contact_btn': 'Contact Us',
        'help.category.general': 'General',
        'help.category.technical': 'Technical',
        'help.category.privacy': 'Privacy',
        'help.faq.q1': 'Is TipsNorge free to use?',
        'help.faq.a1': 'Yes, TipsNorge is a free service for all citizens.',
        'help.faq.q2': 'Who receives my reports?',
        'help.faq.a2': 'Reports are automatically sent to the responsible authority based on category and location.',
        'help.faq.q3': 'Can I remain anonymous?',
        'help.faq.a3': 'Yes, you can choose not to provide your name. However, authorities cannot contact you for follow-up.',
        'help.faq.q4': 'How do I delete my account?',
        'help.faq.a4': 'Go to Profile > Delete my account. This permanently deletes all data.',
        'help.faq.q5': 'What happens if I\'m offline?',
        'help.faq.a5': 'Your report is saved locally and sent automatically when you reconnect.',
        'help.faq.q6': 'The app can\'t find my location',
        'help.faq.a6': 'Make sure you\'ve allowed location access in your browser settings. iPhone: Settings > Privacy > Location Services. Android: Settings > Location.',
        'help.faq.q7': 'How long does it take to fix the issue?',
        'help.faq.a7': 'This varies. Critical issues are prioritized within 24-48 hours, cosmetic issues are scheduled for maintenance rounds.',
        'help.faq.q8': 'Who can see my photos?',
        'help.faq.a8': 'Photos are only visible to the authority handling the case. They are never shown publicly linked to your identity.',

        'home.admin_login': 'Admin Login',
        'home.map_title': 'Map overview of nearby issues',
        'home.track_link': 'Track issue',

        // Track
        'track.invalid_id': 'Invalid ID',
        'track.assigned_authority': 'Assigned Authority',
        'track.privacy_notice': 'Images are hidden for privacy reasons and are only visible to authorized personnel.',
        'track.back_to_feed': 'Back to Feed',
        'track.enter_id_prompt': 'Enter the case number above to see the status.',
        'track.timeline_title': 'Case Timeline',
        'track.timeline_empty': 'No updates yet.',
        'track.timeline_status': 'Status changed to',
        'track.timeline_update': 'Update',
        'track.category_label': 'Category',
        'track.severity_label': 'Severity',

        // Home Feed
        'home.recent_activity': 'Recent Activity',
        'home.no_activity': 'No recent activity.',
        'home.time.just_now': 'Just now',
        'home.time.min_ago': 'm ago',
        'home.time.hour_ago': 'h ago',
        'home.time.day_ago': 'd ago',
        'home.tabs.my_reports': 'My Reports',
        'home.tabs.community': 'Nearby',
        'nav.home': 'Home',
        'nav.map': 'Map',
        'nav.report': 'Report',
        'nav.my_reports': 'My Reports',
        'nav.profile': 'Profile',
        'nav.help': 'Help',

        // Report
        'report.title': 'New Report',
        'report.camera_placeholder': 'Take a photo of the issue',
        'report.open_camera': 'Open Camera',
        'report.gallery': 'Gallery',
        'report.locating': 'Locating you...',
        'report.location_found': 'Location found',
        'report.location_unavailable': 'Location not available',
        'report.retry': 'Retry',
        'report.retry_manual': 'Or enter address manually',
        'report.enter_address': 'Enter address...',
        'report.use_address': 'Use this address',
        'report.searching_address': 'Searching...',
        'report.address_not_found': 'Address not found',
        'report.description_label': 'Description (Optional)',
        'report.description_placeholder': 'Describe what you see...',
        'report.sending': 'Sending...',
        'report.submit_btn': 'Submit Report',
        'report.error_photo': 'Please take a photo first.',
        'report.rate_limit_error': 'Too many reports from this device. Please try again later.',
        'report.error_submission': 'Failed to submit report. Please try again.',
        'report.camera_access_error': 'Could not access camera. Please use the upload button instead.',
        'report.analyzing': 'Analyzing image...',
        'report.privacy_warning': 'Please avoid taking photos of people or license plates.',
        'report.location_error': 'Could not fetch location',
        'report.fetch_position': 'Get location',
        'report.analyzing_ai': 'Analyzing...',
        'report.ai_suggested': 'AI Suggested',
        'report.ai_high_confidence': 'High Confidence',
        'report.ai_authority_suggestion': 'Suggested Authority',
        'report.auto_describe': 'Auto-describe with AI',
        'report.object_label': 'Object & Location',
        'report.scene_label': 'Situation & Consequence',
        'report.object_placeholder': 'Describe the object or place (e.g. pothole, broken sign)',
        'report.scene_placeholder': 'What is the problem and why does it need attention?',
        'report.consent': 'I confirm that the information is correct to the best of my knowledge.',
        'report.reporter_info': 'Contact Information',
        'report.login_suggest': 'Log in',
        'report.login_benefit_text': 'Log in to report issues, check status, and communicate with authorities',
        'report.name_label': 'Your Name',
        'report.phone_label': 'Phone Number',
        'report.phone_placeholder': '+47 987 65 432',
        'report.category_label': 'Category',
        'report.select_category': '-- Select category --',
        'report.review_title': 'Review Report',
        'report.review_btn': 'Continue',
        'report.confirm_btn': 'Submit Report',
        'report.edit_btn': 'Edit',
        'report.summary_image': 'Image',
        'report.summary_location': 'Location',
        'report.summary_description': 'Description',
        'report.summary_contact': 'Reporter',
        'report.recommended': 'Recommended',
        'report.validation_title': 'Please check the following:',
        'report.validation.image_required': 'Please take or select a photo of the issue.',
        'report.validation.description_min': 'Description must be at least 3 characters.',
        'report.validation.description_max': 'Description cannot be longer than 500 characters.',
        'report.validation.location_required': 'We need your location to know where the issue is.',
        'report.validation.phone_invalid': 'Please enter a valid Norwegian phone number (8 digits).',
        'audit.referred': 'Case referred to new authority',
        'audit.transferred': 'Case transferred to new authority',
        'audit.reason': 'Reason',
        'audit.reopened_admin': 'Case reopened',
        'audit.type_DECISION': 'Decision',
        'audit.type_ASSIGNMENT': 'Assignment',
        'audit.type_EXTERNAL': 'External',
        'audit.type_CITIZEN': 'Citizen',
        'audit.type_SYSTEM': 'System',
        'audit.type_INFO': 'Info',
        'track.not_found_title': 'Report not found',
        'track.municipality_label': 'Municipality',
        'track.authority_label': 'Responsible Authority',
        'track.update_label': 'Update',
        'track.feedback_satisfied': 'How satisfied are you with the solution?',
        'track.submitting': 'Submitting...',
        'track.unknown': 'Unknown',
        'track.general': 'General',
        'track.evidence_alt': 'Evidence',
        'track.no_reports_desc': 'You haven\'t submitted any reports yet. Help us keep the community safe.',
        'detail.section_authority': 'Assigned Authority',
        'detail.section_reporter': 'Reported By',

        // Admin Login
        'login.title': 'Admin Login',
        'login.email': 'Email',
        'login.password': 'Password',
        'login.btn': 'Sign In',
        'login.magic_link': 'Send Login Link',
        'login.magic_link_success': 'Login link has been sent to your email!',
        'login.or_continue_with': 'Or continue with',
        'login.no_account_yet': 'No account yet?',
        'login.already_have_account': 'Already have an account?',
        'login.sign_up_now': 'Sign up now',
        'login.login_now': 'Login now',
        'login.enter_email': 'Enter your email',
        'login.error': 'Invalid email or password.',
        'login.staff_only_error': 'This login is for staff only. Citizens should use the main portal.',
        'login.enter_email_error': 'Please enter your email first.',

        // Password Validation
        'auth.password_too_short': 'Password must be at least 8 characters.',
        'auth.password_needs_uppercase': 'Password must contain at least one uppercase letter.',
        'auth.password_needs_lowercase': 'Password must contain at least one lowercase letter.',
        'auth.password_needs_number': 'Password must contain at least one number.',

        // Password Strength
        'auth.criteria_length': 'At least 8 chars',
        'auth.criteria_uppercase': 'Uppercase letter',
        'auth.criteria_lowercase': 'Lowercase letter',
        'auth.criteria_number': 'Number',
        'auth.password_strength': 'Strength:',
        'auth.strength_weak': 'Weak',
        'auth.strength_fair': 'Fair',
        'auth.strength_good': 'Good',
        'auth.strength_strong': 'Strong 💪',
        'login.reset_link_success': 'Reset link sent! Check your email.',
        'login.auth_personnel_only': 'Authorized personnel only',
        'login.forgot_password': 'Forgot?',
        'login.sending': 'Sending...',
        'login.success_check_email': 'Check your email for the confirmation link!',
        'login.use_password': 'Use password instead',
        'login.use_magic_link': 'Use magic link instead',
        'legal.terms_agreement_pre': 'By continuing, you agree to our',
        'legal.terms_agreement_and': 'and',

        // Citizen Login
        'login.citizen_title': 'Sign In',
        'login.citizen_desc': 'By signing in, you can track your submitted reports and manage your profile.',
        'login.google': 'Sign in with Google',
        'login.vipps': 'Continue with Vipps',
        'login.bankid': 'Sign in with BankID',
        'login.coming_soon': 'Coming soon',
        'login.facebook': 'Sign in with Facebook',

        // Profile
        'profile.title': 'My Profile',
        'profile.my_reports': 'My Reports',
        'profile.my_reports_desc': 'Here you can find an overview of all reports you have submitted.',
        'profile.history_placeholder': 'Report history integration coming soon.',
        'profile.sign_out': 'Sign Out',
        'profile.delete_account': 'Delete My Account & All My Data',
        'profile.delete_confirm': 'Are you absolutely sure? This action will permanently delete all your reports and your user account. This cannot be undone.',
        'profile.deleting': 'Deleting data...',
        'report.redirecting': 'Redirecting to feed...',
        'track.not_found_error': 'No report found with this ID.',

        // Admin Dashboard
        'dashboard.title': 'Dashboard',
        'dashboard.logged_in_as': 'Logged in as',
        'dashboard.logout': 'Logout',
        'dashboard.list': 'List',
        'dashboard.grid': 'Grid',
        'dashboard.map': 'Map',
        'dashboard.filter': 'Filter',
        'dashboard.all': 'All',
        'dashboard.status': 'Status',
        'dashboard.date': 'Date',
        'dashboard.location': 'Location',
        'dashboard.description': 'Description',
        'dashboard.actions': 'Actions',
        'dashboard.view_details': 'View Details',
        'dashboard.no_reports': 'No reports found',
        'dashboard.clear_filter': 'Clear filter',
        'dashboard.delete_selected': 'Delete Selected',
        'dashboard.delete_confirm': 'Are you sure you want to delete the selected reports? This action cannot be undone.',
        'dashboard.documentation': 'Documentation',
        'dashboard.map_markers': 'Map Markers',
        'dashboard.heatmap': 'Heatmap',
        'dashboard.overview': 'Case Overview',
        'dashboard.unknown': 'Unknown Location',
        'dashboard.no_desc': 'No description',
        'dashboard.authorities': 'Authorities',
        'dashboard.categories': 'Categories',
        'dashboard.users': 'Users',
        'dashboard.manage_authorities': 'Manage Authorities',
        'dashboard.manage_users': 'Manage Users',
        'dashboard.load_more': 'Load More',
        'dashboard.exporting': 'Exporting...',
        'dashboard.export_selected': 'Export Selected',
        'dashboard.export_success': 'Exported successfully!',
        'dashboard.export_error': 'Failed to export reports.',
        'dashboard.search': 'Search...',
        'dashboard.sort_by_status': 'Sort by status',
        'dashboard.sort_by_date': 'Sort by date',
        'dashboard.sort_by_location': 'Sort by location',
        'dashboard.sort_by_severity': 'Sort by severity',
        'dashboard.select_all': 'Select all reports',
        'dashboard.my_cases': 'My Cases',
        'dashboard.unassigned': 'Unassigned',
        'dashboard.case_number': 'Case #',
        'dashboard.search_placeholder': 'Search by case number (e.g. TN-2026-X)...',
        'dashboard.no_reports_found': 'No case found with this number',
        'dashboard.search_error': 'Error searching for case',

        // Case Detail
        'detail.back': 'Back to Dashboard',
        'detail.case_id': 'Case ID',
        'detail.case_number': 'Case #',
        'detail.no_image': 'No Image Available',
        'detail.failed_image': 'Failed to load image',
        'detail.open_link': 'Open image',
        'detail.delete_case': 'Delete Case',
        'detail.delete_confirm': 'Are you sure you want to delete this case? This action cannot be undone.',
        'detail.unknown_location': 'Unknown Location',
        'detail.no_desc_provided': 'No description provided.',
        'detail.actions': 'Actions',
        'detail.mark_resolved': 'Mark Resolved',
        'detail.start_processing': 'Start Processing',
        'detail.processing_started': 'Processing started',
        'detail.status_updated': 'Status updated!',
        'detail.mark_progress': 'Mark In Progress',
        'detail.reporter_contact': 'Reporter Contact',
        'detail.email': 'Email',
        'detail.phone': 'Phone',
        'detail.reopen_case': 'Reopen Case',
        'detail.assign_transfer': 'Transfer',
        'detail.transfer_case': 'Transfer Case',
        'detail.wait_external': 'Wait for External',
        'detail.complete_case': 'Complete Case (Close)',
        'detail.resume_processing': 'Resume Processing',
        'detail.section_description': 'Description',
        'detail.section_classification': 'Classification',
        'detail.not_categorized': 'Not categorized',
        'detail.dispatch': 'Send to Authority',
        'detail.dispatched_success': 'Case dispatched successfully!',
        'detail.assigned_to': 'Assigned Authority',
        'detail.handler': 'Handler',
        'detail.unassigned_handler': 'No individual handler assigned',
        'detail.claim_case': 'Assign to me',
        'detail.claim_success': 'You have claimed the case',
        'detail.claim_error': 'Failed to claim the case',
        'detail.report_not_found': 'Report not found.',
        'detail.internal_log': 'Internal Log',
        'detail.entries': 'entries',
        'detail.no_updates': 'No updates yet',
        'detail.new_update': 'New Update',
        'detail.internal_note': 'Internal Note',
        'detail.update_placeholder': 'Write an update or comment...',
        'detail.unassigned_authority': 'No authority assigned',
        'detail.status_changed': 'Status changed',
        'detail.severity_match': 'Severity Grade',
        'detail.severity_changed': 'Severity changed to',
        'detail.category_changed': 'Category changed to',
        'detail.save_changes': 'Save Changes',
        'detail.updated': 'Updated!',
        'detail.select_authority': 'Select Authority',
        'detail.dispatch_helper': 'Select an authority to handle this case. This will notify them and give them access to the report.',
        'detail.transfer_reason': 'Transfer Reason',
        'detail.transfer_reason_placeholder': 'Reason for transferring...',
        'detail.assign_to_authority': 'Assign to Authority',
        'detail.select_target_authority': 'Select recipient for this case',
        'detail.search_authority': 'Search for authority...',
        'detail.reason_label': 'Assignment Reason',
        'detail.confirm_assignment': 'Confirm Assignment',
        'detail.dispatched_to': 'Dispatched to:',
        'detail.update_success': 'Update posted!',
        'detail.update_error': 'Failed to post update',
        'detail.update_comment': 'Write a comment...',
        'detail.is_internal': 'Internal (authorized only)',
        'detail.post_update': 'Post Update',
        'detail.press_enter': 'Press Enter to post',
        'detail.unknown_user': 'Unknown User',
        'detail.resolution_code': 'Reason / Outcome',
        'detail.resolution_prompt': 'Enter resolution code (FIXED, DISMISSED, REFERRED, NO_ACTION):',
        'detail.closing_comment': 'Closing Comment',
        'detail.closing_comment_placeholder': 'Describe the resolution...',
        'detail.confirm_resolution': 'Complete',
        'detail.timeline': 'Timeline',
        'detail.fetch_auth_error': 'Failed to fetch authority details',
        'detail.email_subject': 'New Issue Assigned:',
        'detail.email_body': 'A new issue has been assigned to your authority.',
        'detail.view_in_portal': 'View in Admin Portal',
        'detail.access_denied': 'Access Denied',
        'detail.pdf_error': 'Case dispatched, but PDF generation failed.',
        'detail.delete_error': 'Error deleting report:',
        'detail.delete_success': 'Report deleted successfully',
        'detail.email_best_regards': 'Best regards',
        'detail.email_issue_id': 'Issue ID',
        'detail.email_status': 'Status',

        // Authorities
        'authorities.title': 'Authorities',
        'authorities.broadcast_title': 'Send Email to Selected',
        'authorities.broadcast_subtitle': 'Recipients:',
        'authorities.broadcast_subject': 'Subject',
        'authorities.broadcast_subject_placeholder': 'Ex: Important update regarding...',
        'authorities.broadcast_message': 'Message',
        'authorities.broadcast_message_placeholder': 'Write your message here...',
        'authorities.broadcast_send': 'Send Email',
        'authorities.broadcast_validation': 'Please fill in subject and message, and select at least one recipient.',
        'authorities.broadcast_success': 'Email sent to selected recipients.',
        'authorities.send_email': 'Send Email',
        'authorities.add': 'Add Authority',
        'authorities.create': 'Create Authority',
        'authorities.edit': 'Edit Authority',
        'authorities.name': 'Name',
        'authorities.type': 'Type',
        'authorities.email': 'Email',
        'authorities.webhook': 'Webhook URL',
        'authorities.status': 'Status',
        'authorities.active': 'Active',
        'authorities.inactive': 'Inactive',
        'authorities.actions': 'Actions',
        'authorities.no_authorities': 'No authorities found.',
        'authorities.created_success': 'Authority created!',
        'authorities.updated_success': 'Authority updated!',
        'authorities.type_municipal': 'Municipal',
        'authorities.type_road': 'Road',
        'authorities.type_civil': 'Civil',
        'authorities.type_private': 'Private',
        'authorities.contact': 'Contact',
        'authorities.active_label': 'Active',
        'authorities.placeholder_name': 'e.g. Road Authority West',
        'authorities.delete_confirm': 'Are you sure you want to delete this authority?',
        'authorities.selected': 'selected',
        'authorities.activate_selected': 'Activate Selected',
        'authorities.deactivate_selected': 'Deactivate Selected',
        'authorities.magic_link_enabled': 'Magic Link Active',
        'authorities.magic_link_desc': 'Allow case handling via direct links without a password.',
        'authorities.token_validity': 'Token Validity (hours)',

        // Users
        'users.title': 'User Management',
        'users.add': 'Add User',
        'users.tab_admins': 'Admins',
        'users.tab_staff': 'Staff',
        'users.tab_authorities': 'Authority Users',
        'users.tab_end_users': 'Citizens',
        'users.create': 'Create New User',
        'users.edit': 'Edit User',
        'users.name': 'Name',
        'users.joined': 'Joined',
        'users.first_name': 'First Name',
        'users.last_name': 'Last Name',
        'users.email': 'Email',
        'users.password': 'Password',
        'users.new_password': 'New Password',
        'users.role': 'Role',
        'users.authority': 'Authority',
        'users.status': 'Status',
        'users.active': 'Active',
        'users.disabled': 'Disabled',
        'users.actions': 'Actions',
        'users.no_users': 'No users found.',
        'users.created_success': 'User created successfully!',
        'users.updated_success': 'User updated successfully!',
        'users.password_reset_success': 'Password reset successfully!',
        'users.error_create': 'Error creating user',
        'users.error_update': 'Error updating user',
        'users.error_reset_password': 'Error resetting password',
        'users.error_status_update': 'Error updating status',
        'users.new_password_placeholder': 'Enter new password',
        'users.role_admin': 'Administrator',
        'users.role_authority_user': 'Case Officer',
        'users.assign_authority': 'Assign Authority',
        'users.select_authority': '-- Select Authority --',
        'users.reset_password': 'Reset Password',
        'users.reset_password_desc': 'Enter a new password for',
        'users.enable': 'Enable',
        'users.disable': 'Disable',
        'users.confirm_disable': 'Are you sure you want to disable this user?',
        'users.confirm_enable': 'Are you sure you want to enable this user?',
        'users.managed_via_db': 'Managed via DB',
        'users.edit_user': 'Edit User',
        'users.save_changes': 'Save Changes',
        'users.saving': 'Saving...',
        'users.creating': 'Creating...',
        'users.inviting': 'Sending invitation...',
        'users.send_invitation': 'Send Invitation',
        'users.resend_invite': 'Resend Invitation',
        'users.resending': 'Resending...',
        'users.resetting': 'Resetting...',
        'users.delete_confirm_title': 'Delete User',
        'users.delete_confirm_message': 'Are you sure you want to delete this user? This action cannot be undone.',
        'setup_password.title': 'Complete Registration',
        'setup_password.desc': 'Please choose a secure password for your new account.',
        'setup_password.password_label': 'New Password',
        'setup_password.confirm_label': 'Confirm Password',
        'setup_password.placeholder': 'At least 8 characters',
        'setup_password.submit': 'Set Password',
        'setup_password.success': 'Password set successfully! Logging you in...',
        'setup_password.error': 'Failed to set password. Please try again.',
        'setup_password.mismatch': 'Passwords do not match.',
        'setup_password.invalid_link': 'Invalid or expired link',
        'setup_password.password_length': 'Password must be at least 8 characters',
        'setup_password.verifying': 'Verifying invitation...',

        // Statuses
        'status.OPEN': 'OPEN',
        'status.IN_PROGRESS': 'IN PROGRESS',
        'status.WAITING': 'WAITING',
        'status.RESOLVED': 'RESOLVED',
        'status.ALL': 'All',
        'status_desc.OPEN': 'Report Received',
        'status_desc.IN_PROGRESS': 'In Progress',
        'status_desc.RESOLVED': 'Issue Resolved',

        // Offline
        'report.offline_saved': 'Your report has been saved locally and will be submitted automatically once you are back online.',
        'report.success_title': 'Report Received!',
        'report.success_desc': 'Thank you for contributing to a safer community. Your report has been registered.',
        'report.tracking_id': 'Tracking ID',
        'report.tracking_tip': 'Save this ID to check the status of your report later.',
        'report.track_btn': 'Track Report Now',
        'report.back_home': 'Back to Home',
        'report.offline_title': 'Offline Mode',
        'report.syncing': 'Syncing report...',
        'report.get_receipt': 'Get a receipt',
        'report.send_receipt': 'Send receipt',
        'report.receipt_sent': 'Receipt sent!',
        'report.receipt_error': 'Failed to send receipt. Try again later.',
        'report.pick_from_map': 'Pick from map',
        'report.confirm_location': 'Confirm location',
        'report.map_picker_help': 'Click on the map to select exact location',
        'track.title': 'Track Your Report',
        'track.subtitle': 'Enter your tracking ID to see the latest updates.',
        'track.placeholder': 'Enter tracking ID (e.g., uuid)',
        'track.search_placeholder': 'Enter case ID (e.g. TN-2024-001)',
        'track.search_btn': 'Search',
        'track.not_found': 'No report found with this ID. Please check the ID and try again.',
        'track.status_label': 'Current Status',
        'track.details_label': 'Report Details',
        'track.date_label': 'Submitted Date',
        'track.location_label': 'Location',
        'severity.LOW': 'Low',
        'severity.MEDIUM': 'Medium',
        'severity.HIGH': 'High',
        'severity.CRITICAL': 'Critical',
        'dashboard.severity': 'Severity',

        // Quick Wins
        'report.scanning': 'Scanning image...',
        'track.rate_fix': 'How would you rate the resolution?',
        'track.feedback_placeholder': 'Optional comment for the authorities...',
        'track.submit_feedback': 'Submit Feedback',
        'track.feedback_thank_you': 'Thank you for your feedback!',

        // Cookie Consent
        'cookie.title': 'We use cookies',
        'cookie.desc': 'We use cookies to ensure the site works correctly and to understand how you use our service.',
        'cookie.accept_all': 'Accept All',
        'cookie.reject_all': 'Reject All',
        'cookie.preferences': 'Preferences',
        'cookie.save': 'Save Preferences',
        'cookie.necessary.title': 'Necessary',
        'cookie.necessary.desc': 'Required for the site to function, e.g., for authentication.',
        'cookie.prefs.title': 'Functional',
        'cookie.prefs.desc': 'Remember choices like language and theme.',
        'cookie.stats.title': 'Statistics',
        'cookie.stats.desc': 'Help us improve the service by collecting anonymous usage data.',

        // Admin Analytics & Map
        'dashboard.analytics': 'Analytics',
        'dashboard.hotspot': 'Hotspot',
        'dashboard.reports_nearby': 'reports nearby',
        'analytics.total_reports': 'Total Reports',
        'analytics.avg_rating': 'Avg. Citizen Rating',
        'analytics.avg_resolution': 'Avg. Resolution Time',
        'analytics.completion_rate': 'Completion Rate',
        'analytics.status_distribution': 'Status Distribution',
        'analytics.community_impact': 'Community Impact',
        'analytics.hours': 'hrs',
        'analytics.days': 'days',
        'analytics.safety_index': 'Safety Index',
        'analytics.safety_index_desc': 'Based on resolution speed',
        'analytics.trust_score': 'Trust Score',
        'analytics.trust_score_desc': 'Citizen feedback positive',
        'analytics.performance_summary': '"Data indicates a 15% improvement in response time since last month."',

        // Case Detail & Referral
        'detail.refer_case': 'Refer Case',
        'detail.referral_reason': 'Reason for Referral',
        'detail.referral_reason_placeholder': 'Why is this case being referred?',
        'detail.referral_success': 'Case referred successfully!',
        'detail.no_authority_assigned': 'No authority assigned',
        'detail.assign_now': 'Assign now',
        'detail.referral_error': 'Failed to refer case.',
        'detail.timeline_internal': 'Internal Log',
        'detail.timeline_public': 'Shared with Resident',
        'nav.notifications': 'Notifications',
        'nav.no_notifications': 'No new notifications',


        // Support System
        'support.title': 'Support',
        'support.new_ticket': 'New Request',
        'support.subject_placeholder': 'What is this about?',
        'support.message_placeholder': 'Describe your issue or question...',
        'support.priority': 'Priority',
        'support.priority.NORMAL': 'Normal',
        'support.priority.HIGH': 'High',
        'support.status.OPEN': 'Open',
        'support.status.IN_PROGRESS': 'In Progress',
        'support.status.CLOSED': 'Closed',
        'support.no_tickets': 'No active requests.',
        'support.created_at': 'Created',
        'support.admin_inbox': 'Admin Inbox',
        'support.all_tickets': 'All Requests',
        'support.respond': 'Provide Feedback',
        'support.respond_email': 'Respond via Email',
        'support.admin_response': 'Admin Response',
        'support.response_placeholder': 'Type your response here...',
        'support.resolve_btn': 'Resolve & Send Response',
        'support.update_btn': 'Update with Response',
        'support.response_required': 'Please provide a response before proceeding',
        'support.delete_confirm': 'Are you sure you want to delete this request?',

        // System Settings
        'settings.system': 'System Settings',
        'settings.allow_guest': 'Allow Guest Reporting',
        'settings.allow_guest_desc': 'If disabled, only logged-in users can submit reports.',
        'report.guest_restricted': 'Guest reporting is currently disabled.',
        'report.login_required': 'Please log in to submit a report.',
        'settings.enable_vipps': 'Enable Vipps Login',
        'settings.enable_vipps_desc': 'Show Vipps as an option on the login page.',
        'settings.enable_bankid': 'Enable BankID Login',
        'settings.enable_bankid_desc': 'Show BankID as an option on the login page.',
        'settings.enable_google': 'Enable Google Login',
        'settings.enable_google_desc': 'Allow users to sign in with Google.',
        'settings.enable_email_password': 'Enable Email/Password',
        'settings.enable_email_password_desc': 'Allow users to sign in with email and password.',

        'error.boundary_title': 'Something went wrong',
        'error.boundary_desc': 'We apologize! An unexpected error occurred. Please try again.',
        'error.tech_details': 'Technical details',
        'error.reload_btn': 'Reload the page',
        'error.go_home': 'Go to home page',
        'error.support_hint': 'If the problem persists, please contact support.',
        'error.no_location': 'No location data available',
        'error.connection_title': 'Connection Error',
        'error.profile_load_fail': 'Could not load user profile. Check your connection.',

        // Sharing
        'share.title': 'Share TipsNorge',
        'share.subtitle': 'Help us improve the neighborhood by inviting friends and family.',
        'share.btn': 'Share with others',
        'share.copy': 'Copy link',
        'share.copied': 'Link copied!',
        'share.whatsapp': 'WhatsApp',
        'share.messenger': 'Messenger',
        'share.sms': 'SMS',
        'share.native': 'Share...',
        'share.message': 'I am using TipsNorge to make our neighborhood better! Check it out here: ',
    },
};
